import React from 'react';
import { Layers as LayersIcon } from '@mui/icons-material';
import { TrayContents } from './tray-contents';

export const icon = <LayersIcon />;

export const title = 'Selected Layers';

export const trayContents = TrayContents;
